import { IPermissionEdit } from "./IPermissionEdit";

export class PermissionReport {
    public selectAllPermissionReport!:IPermissionEdit
    
    public LobbyEdit!: {
        selectAll: boolean;
        viewLobbyEditReports: IPermissionEdit;
        editLobbyEditReports: IPermissionEdit;
        shareTemplateLobbyEditReports: IPermissionEdit;
        deleteTemplateLobbyEditReports: IPermissionEdit;
    }

    public LobbyActivity! :{
        selectAll: boolean;
        viewLobbyActivity: IPermissionEdit;
        editLobbyActivity: IPermissionEdit;
        shareTemplateLobbyActivity: IPermissionEdit;
        deleteTemplateLobbyActivity: IPermissionEdit;
        viewStaffSignInOutReport: IPermissionEdit;
    }


}